import { WorkloadWeekProps } from './types';
import { getPrefix } from './helpers';
import { shortDate } from '@utils/i18n';
import { useTranslation } from 'react-i18next';
import { cn } from '@utils/cn';
import { addWeeks } from 'date-fns';
import { useWorkload } from '@contexts/workload';
import { getFirstDayOfBusinessWeek, getLastDayOfBusinessWeek } from '@contexts/workload/constants';
import { DatePicker } from '@components/ui/form/date';

export const WorkloadWeek = ({ date, first }: WorkloadWeekProps) => {
  const { isTwoWeekly, date: contextDate, setData } = useWorkload();
  const { t } = useTranslation('app');
  const prefix = getPrefix(date);

  return (
    <div
      className={cn(
        'flex select-none flex-col font-bold',
        isTwoWeekly ? 'justify-center' : 'h-9 justify-end',
      )}>
      {!isTwoWeekly && <span className="text-xs text-neutral-300">{t(prefix)}</span>}
      <div className={cn('flex items-center gap-2', isTwoWeekly && 'justify-center')}>
        <span className={cn('text-neutral-500', isTwoWeekly ? 'text-m' : 'text-sm')}>
          {[
            shortDate(getFirstDayOfBusinessWeek(date)),
            shortDate(getLastDayOfBusinessWeek(isTwoWeekly ? addWeeks(date, 1) : date)),
          ].join(' - ')}
        </span>
        {!isTwoWeekly && first && (
          <DatePicker
            mode="single"
            noText
            noRemove
            className="h-fit w-fit border-0 p-1 text-sm"
            value={contextDate}
            onChange={(newDate) => {
              if (!newDate) return;
              setData('date', newDate);
            }}
          />
        )}
      </div>
    </div>
  );
};
